export const groupArrayByIndex = <
  T extends Record<string, any>,
  K extends keyof T
>(
  target: T[],
  index: K
): Record<string, T> => {
  return target.reduce((previousValue, currentValue) => {
    previousValue[currentValue[index]] = currentValue;
    return previousValue;
  }, {} as Record<K, T>);
};
export const groupArrayByIndexMulti = <
  T extends Record<string, any>,
  K extends keyof T
>(
  target: T[],
  index: K
): Record<string, T[]> => {
  return target.reduce((previousValue, currentValue) => {
    if (!previousValue[currentValue[index]]) {
      previousValue[currentValue[index]] = [];
    }
    previousValue[currentValue[index]].push(currentValue);
    return previousValue;
  }, {} as Record<K, T[]>);
};
